module.exports = __webpack_public_path__ + "img/20190617162042205.22ccdce6.png";